export default __webpack_public_path__ + "static/media/profileBG.0a237d0a.svg";